import { Component, Inject, OnInit,Input } from '@angular/core';
import { AdminService } from '../admin.service';
import { ActivatedRoute } from '@angular/router';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-admin-template',
  templateUrl: './admin-template.component.html',
  styleUrls: ['./admin-template.component.css'],
})
export class AdminTemplateComponent implements OnInit {
  reviewPendingTemplates: any;
 @Input() merchant_id: string;
  checked: boolean = false;
  selectedTemplatedetails: any;
  selectedTemplateIndex: number;
  allTemplates: any;
  searchValue:string;
  activeCard: number;
  pendingTemplates: any;
  ApprovedTemplates: any;
  intialAllTemplates: any;

  
  

  constructor(
    private adminService: AdminService,
    private activatedRoute: ActivatedRoute,
    private _matDialog: MatDialog
  ) {}

  ngOnInit(): void {
    //this.merchant_id = this.activatedRoute.snapshot.params.merchantId;
    this.getReviewPendingTemplate();
    // this.getAllTemplates();
  }

  getReviewPendingTemplate() {
    this.adminService
      .getTemplateByMerchantID(this.merchant_id)
      .subscribe((response) => {
        this.intialAllTemplates = response.body.data.sort((a, b) => { return <any>new Date(b.created_at) - <any>new Date(a.created_at); });
        this.reviewPendingTemplates = response.body.data.sort((a, b) => { return b.created_at - a.created_at; });
        if (response.body.data.length !== 0) {
          this.selectedTemplateIndex = 0;
          this.selectedTemplatedetails = response.body.data[0];
        }
        this.pendingTemplates= this.reviewPendingTemplates.filter(object => object.status === "PENDING_REVIEW");
        this.ApprovedTemplates= this.reviewPendingTemplates.filter(object => object.status === "ACTIVE");
      });
  }

  // getAllTemplates(){
  //   this.adminService.getAllTemplates().subscribe(response=>{
  //     this.allTemplates = response.body.data
  //     if(response.body.data.length !== 0){
  //       this.selectedTemplateIndex=0
  //       this.selectedTemplatedetails=response.body.data[0]
  //     }
  //   })
  // }

  verifyTemplate(action) {
    let request = {
      status: action,
      status_reason: 'Too generic.',
    };
    this.adminService
      .updateTemplate(this.merchant_id, this.selectedTemplatedetails.name, request)
      .subscribe(
        (response) => {},
        (error) => {
          if (error.status == 200) {
            this.getReviewPendingTemplate();
            // this._snackBar.open('Verified Successfully', 'close', {
            //   duration: 3000,
            //   horizontalPosition: this.horizontalPosition,
            //   verticalPosition: this.verticalPosition,
            // });
          }
        }
      );
  }

  changeAgreeButton(){
    this.checked = !this.checked
  }

  openRejectpopup() {
    const dialogRef = this._matDialog.open(RejectDialog,{
      data: {merchantId:this.merchant_id,selectedTemplatedetails:this.selectedTemplatedetails},
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getReviewPendingTemplate();
    })
  }

  selectTemplate(template, index) {
    this.selectedTemplateIndex = index;
    this.selectedTemplatedetails = template;
  }
  getMessageText(){
    if(this.selectedTemplatedetails){
    let type =this.selectedTemplatedetails.template.type
    return this.selectedTemplatedetails.template[type][Object.keys(this.selectedTemplatedetails.template[type])[0]]
    }
  }

  searchTemplates(event){

    this.reviewPendingTemplates =   this.intialAllTemplates.filter((obj) =>
  JSON.stringify(obj).toLowerCase().includes(this.searchValue.toLowerCase())
)
  }

  sortRequests(action){
    this.activeCard = null;
    if(action === 'Pending'){
      this.activeCard = 1;
      this.reviewPendingTemplates= this.pendingTemplates.sort((a, b) => { return b.created_at - a.created_at; });
    }else if(action === 'Active'){
      this.activeCard = 2;
      this.reviewPendingTemplates= this.ApprovedTemplates.sort((a, b) => { return b.created_at - a.created_at; });
    }else{
      this.reviewPendingTemplates = this.intialAllTemplates 
    }
   
  }
 
}


@Component({
  selector: 'reject-dialog',
  templateUrl: 'reject-dialog.html',
  styleUrls: ['./admin-template.component.css'],
})
export class RejectDialog {
  merchantID: any;
  selectedTemplatedetails: any;
   rejectedReason:any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(public dialogRef: MatDialogRef<RejectDialog>, @Inject(MAT_DIALOG_DATA) public data: any,private adminService:AdminService, private _snackBar:MatSnackBar ) {
    this.merchantID = this.data.merchantId
    this.selectedTemplatedetails =this.data.selectedTemplatedetails
  }

  closePopup() {
    this.dialogRef.close();
  }

  rejectTemplate() {
    if(!this.selectedTemplatedetails){
      this._snackBar.open('Template Name Not Found', 'close', {
        duration: 3000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        });
        return;
    }
    let request = {
      status: "REJECTED",
      status_reason: this.rejectedReason,
    };
    this.adminService
      .updateTemplate(this.merchantID, this.selectedTemplatedetails.name, request)
      .subscribe(
        (response) => {},
        (error) => {
          if (error.status == 200) {
            this.dialogRef.close();
          this._snackBar.open('Rejected Successfully', 'close', {
            duration: 3000,
              horizontalPosition: this.horizontalPosition,
              verticalPosition: this.verticalPosition,
            });
          }else{
            this._snackBar.open(error.error.message, 'close', {
            duration: 3000,
              horizontalPosition: this.horizontalPosition,
              verticalPosition: this.verticalPosition,
            });
          }
        }
      );
  }

  clearInput(){
    this.rejectedReason =""
  }

  
}
